import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { filterRecursive, findRecursive, flatUtHierarki } from './util';
import { Organisasjon } from './Virksomhetsvelger';
import { VirksomhetsvelgerContext } from './VirksomhetsvelgerContext';
export const VirksomhetsvelgerProvider = t0 => {
  const $ = _c(26);
  const {
    children,
    organisasjonstre: orgtre,
    onOrganisasjonChange,
    initValgtOrgnr,
    kunHovedenheter
  } = t0;
  let t1;
  if ($[0] !== kunHovedenheter || $[1] !== orgtre) {
    t1 = kunHovedenheter ? orgtre.map(_temp) : flatUtHierarki(orgtre);
    $[0] = kunHovedenheter;
    $[1] = orgtre;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const organisasjonstre = t1;
  const [søketekst, setSøketekst] = useState("");
  let t2;
  bb0: {
    if (søketekst === "") {
      t2 = organisasjonstre;
      break bb0;
    }
    let t3;
    if ($[3] !== søketekst) {
      t3 = o => o.orgnr.includes(søketekst) || o.navn.toLowerCase().includes(søketekst.toLowerCase());
      $[3] = søketekst;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== organisasjonstre || $[6] !== t3) {
      t4 = filterRecursive(organisasjonstre, t3);
      $[5] = organisasjonstre;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t2 = t4;
  }
  const aktivtOrganisasjonstre = t2;
  let t3;
  if ($[8] !== aktivtOrganisasjonstre[0] || $[9] !== initValgtOrgnr || $[10] !== organisasjonstre) {
    t3 = () => {
      const foersteValgbare = aktivtOrganisasjonstre[0]?.underenheter[0] ?? aktivtOrganisasjonstre[0];
      if (initValgtOrgnr !== undefined) {
        return findRecursive(organisasjonstre, org_0 => org_0.orgnr === initValgtOrgnr) ?? foersteValgbare;
      }
      return foersteValgbare;
    };
    $[8] = aktivtOrganisasjonstre[0];
    $[9] = initValgtOrgnr;
    $[10] = organisasjonstre;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const [valgtOrganisasjon, setValgtOrganisasjon] = useState(t3);
  let t4;
  if ($[12] !== onOrganisasjonChange || $[13] !== valgtOrganisasjon) {
    t4 = () => {
      if (valgtOrganisasjon?.orgnr) {
        onOrganisasjonChange(valgtOrganisasjon);
      }
    };
    $[12] = onOrganisasjonChange;
    $[13] = valgtOrganisasjon;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = valgtOrganisasjon?.orgnr;
  let t6;
  if ($[15] !== onOrganisasjonChange || $[16] !== t5 || $[17] !== valgtOrganisasjon) {
    t6 = [onOrganisasjonChange, valgtOrganisasjon, t5];
    $[15] = onOrganisasjonChange;
    $[16] = t5;
    $[17] = valgtOrganisasjon;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  useEffect(t4, t6);
  if (valgtOrganisasjon === undefined) {
    return null;
  }
  let t7;
  if ($[19] !== aktivtOrganisasjonstre || $[20] !== søketekst || $[21] !== valgtOrganisasjon) {
    t7 = {
      velgUnderenhet: setValgtOrganisasjon,
      aktivtOrganisasjonstre,
      valgtOrganisasjon,
      søketekst,
      setSøketekst
    };
    $[19] = aktivtOrganisasjonstre;
    $[20] = søketekst;
    $[21] = valgtOrganisasjon;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const context = t7;
  let t8;
  if ($[23] !== children || $[24] !== context) {
    t8 = <VirksomhetsvelgerContext.Provider value={context}>{children}</VirksomhetsvelgerContext.Provider>;
    $[23] = children;
    $[24] = context;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
function _temp(org) {
  return {
    ...org,
    underenheter: []
  };
}